class APIS {
	apis() {
		return {
			sidebar_users: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/user/list'
			},
			fetch_Conversions: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/user/messages'
			},
			create_user: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/users/create-own-user'
			},
			delete: {
				headers: {
					'xt-user-token': null
				},
				method: 'delete',
				path: '/backend/users/delete/:id'
			},
			fetchGroupMembers: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/members/list/:group_id'
			},
			removeGroupMembers: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/members/remove'
			},
			addGroupMembers: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/add/member'
			},
			deleteGroup: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/groups/remove/:group_id'
			},
			updateGroupDetails: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/group/update'
			}
		};
	}
}

export default new APIS();
